import {
  Mail,
  LayoutDashboard, Smartphone, Users, UserCheck, Receipt, Landmark, ArrowLeftRight, Trophy, Percent,
  CreditCard, Scale, Package, BarChart3, ShieldCheck, Settings, History,
} from "lucide-react";

export const NAV = [
  { title: "Vue d'ensemble", items: [{ label: "Tableau de bord", path: "/", icon: LayoutDashboard, module: "dashboard" }] },
  {
    title: "Réseau commercial",
    items: [
      { label: "Terminaux (TPE)", path: "/tpe", icon: Smartphone, module: "tpes" },
      { label: "Revendeurs", path: "/revendeurs", icon: Users, module: "revendeurs" },
      { label: "Superviseurs", path: "/superviseurs", icon: UserCheck, module: "superviseurs" },
    ],
  },
  {
    title: "Finance",
    items: [
      { label: "TFJ journalier", path: "/tfj", icon: Receipt, module: "tfj" },
      { label: "Trésorerie & comptes", path: "/tresorerie", icon: Landmark, module: "tresorerie" },
      { label: "Opérations", path: "/operations", icon: ArrowLeftRight, module: "operations" },
      { label: "Gains", path: "/gains", icon: Trophy, module: "gains" },
      { label: "Commissions", path: "/commissions", icon: Percent, module: "commissions" },
      { label: "Charges & dépenses", path: "/charges", icon: CreditCard, module: "charges" },
      { label: "Dettes & créances", path: "/dettes", icon: Scale, module: "dettes" },
    ],
  },
  {
    title: "Logistique & pilotage",
    items: [
      { label: "Stocks rouleaux & bobines", path: "/stocks", icon: Package, module: "stocks" },
      { label: "Rapports périodiques", path: "/rapports", icon: BarChart3, module: "rapports" },
    ],
  },
  {
    title: "Administration",
    items: [
      { label: "Utilisateurs & permissions", path: "/utilisateurs", icon: ShieldCheck, module: "utilisateurs" },
      { label: "Journal d'audit", path: "/audit", icon: History, module: "audit" },
      { label: "Paramètres des e-mails", path: "/emails", icon: Mail, module: "emails" },
      { label: "Paramètres généraux", path: "/parametres", icon: Settings, module: "parametres" },
    ],
  },
];
